import {Card} from 'react-bootstrap';
import {useNavigate} from 'react-router-dom';
import {useIntl} from 'react-intl';

/**
 * MAQUETTE — onglet « CTI / CSTA Gateway » d'une prestation Centrex.
 * Contenu informatif statique : aucun appel API.
 */
const CtiGateway = (): JSX.Element => {
  const navigate = useNavigate();
  const intl = useIntl();

  return (
    <div className="mt-4">
      <h2 className="text-primary fw-bold text-uppercase mb-4">
        {intl.formatMessage({id: 'TELEPHONIE.CTI.TITRE'})}
      </h2>
      <Card bg="light">
        <Card.Body>
          <p className="fs-6 mb-4">
            {intl.formatMessage({id: 'TELEPHONIE.CTI.DESCRIPTION'})}
            <br />
            {intl.formatMessage({id: 'TELEPHONIE.CTI.VEUILLEZ'})}{' '}
            <span
              className="text-primary cursor-pointer"
              onClick={() => navigate('/support-list')}
            >
              {intl.formatMessage({id: 'TELEPHONIE.CTI.DEMANDER_ACCOUNT_MANAGER'})}
            </span>{' '}
            {intl.formatMessage({id: 'TELEPHONIE.CTI.PLUS_INFORMATIONS'})}
          </p>
          <p className="fs-6 mb-2">{intl.formatMessage({id: 'TELEPHONIE.CTI.DISPONIBLE_POUR'})}</p>
          <ul className="fs-6 mb-0">
            <li>{intl.formatMessage({id: 'TELEPHONIE.CTI.PASSERELLE_CSTA'})}</li>
            <li>{intl.formatMessage({id: 'TELEPHONIE.CTI.LOGICIEL_VTX_PHONE'})}</li>
          </ul>
        </Card.Body>
      </Card>
    </div>
  );
};

export default CtiGateway;
